/* Guide des tailles en grand : ouverture depuis « Trouve ta taille parfaite », agrandissement, fermeture (×, Échap, fond). */
(function () {
  'use strict';

  var modal = document.querySelector('[data-size-guide]');
  if (!modal || modal.__sgBound) return;
  modal.__sgBound = true;

  var triggerSelector = modal.getAttribute('data-trigger');
  var scroller = modal.querySelector('[data-sg-scroll]');
  var img = modal.querySelector('.sg__img');
  var zoomBtn = modal.querySelector('[data-sg-zoom]');
  var closeBtn = modal.querySelector('.sg__close');
  var hint = modal.querySelector('[data-sg-hint]');
  var lastFocus = null;
  var hideTimer = null;

  function loadImage() {
    if (img.getAttribute('src')) return;
    img.setAttribute('srcset', img.getAttribute('data-srcset'));
    img.setAttribute('src', img.getAttribute('data-src'));
  }

  function isOpen() { return modal.classList.contains('is-open'); }
  function isZoomed() { return scroller.classList.contains('is-zoomed'); }

  function setZoom(on, evt) {
    if (on === isZoomed()) return;
    var rx, ry;
    if (evt && img.offsetWidth) {
      var r = img.getBoundingClientRect();
      rx = (evt.clientX - r.left) / r.width;
      ry = (evt.clientY - r.top) / r.height;
    } else {
      rx = (scroller.scrollLeft + scroller.clientWidth / 2) / (img.offsetWidth || 1);
      ry = (scroller.scrollTop + scroller.clientHeight / 2) / (img.offsetHeight || 1);
    }
    scroller.classList.toggle('is-zoomed', on);
    img.setAttribute('sizes', on ? '1080px' : img.getAttribute('data-sizes'));
    if (hint) hint.textContent = on ? 'Fais glisser pour te déplacer · appuie pour dézoomer' : 'Appuie sur le guide pour zoomer';
    zoomBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    zoomBtn.setAttribute('aria-label', on ? 'Réduire le guide' : 'Agrandir le guide');
    scroller.scrollLeft = rx * img.offsetWidth - scroller.clientWidth / 2;
    scroller.scrollTop = ry * img.offsetHeight - scroller.clientHeight / 2;
  }

  function open(trigger) {
    if (isOpen()) return;
    lastFocus = trigger || document.activeElement;
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    loadImage();
    clearTimeout(hideTimer);
    setZoom(false);
    modal.hidden = false;
    scroller.scrollTop = 0;
    scroller.scrollLeft = 0;
    document.documentElement.classList.add('sg-lock');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
      closeBtn.focus({ preventScroll: true });
    });
  }

  function close() {
    if (!isOpen()) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('sg-lock');
    hideTimer = setTimeout(function () { modal.hidden = true; }, 220);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  }

  /* Le lien du calculateur ouvre le guide à la place de son comportement d'origine. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest(triggerSelector);
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open(t);
  }, true);

  /* Chargement anticipé de l'image dès que le client s'approche du lien. */
  ['touchstart', 'mouseover', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.target.closest && e.target.closest(triggerSelector)) loadImage();
    }, { passive: true, capture: true });
  });

  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-sg-close]')) { close(); return; }
    if (e.target.closest('[data-sg-zoom]')) { setZoom(!isZoomed()); return; }
    if (e.target === img) setZoom(!isZoomed(), e);
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var items = [zoomBtn, closeBtn, scroller];
    var i = items.indexOf(document.activeElement);
    if (e.shiftKey && i <= 0) { e.preventDefault(); items[items.length - 1].focus(); }
    else if (!e.shiftKey && (i === items.length - 1 || i === -1)) { e.preventDefault(); items[0].focus(); }
  });
})();
